import { assertClientName } from 'setups/clients'

const client = process.env.REACT_APP_PROJ
assertClientName(client)

export const projectClient = client
